import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {authenticateOnEnter} from './utils/RoutingUtils';
import App from './App.jsx';
import NotFound from './common/NotFound.Page.jsx';
import UserCheckin from './checkins/UserCheckin.jsx';
import Login from './auth/Login.jsx';
import Signup from './auth/Signup.jsx';
import ForgotPasswordRequest from './auth/ForgotPasswordRequest.jsx';
import ForgotPasswordConsume from './auth/ForgotPasswordConsume.jsx';
import Profile from './profile/Profile.jsx';
import ProfileInfo from './profile/ProfileInfo.jsx';
import ProfileSecurity from './profile/ProfileSecurity.jsx';
import ConfirmEmail from './profile/ConfirmEmail.jsx';
import ChangeEmailConfirm from './profile/ChangeEmailConfirm.jsx';
import ChangeEmailVerify from './profile/ChangeEmailVerify.jsx';
import PublicUser from './publicUser/PublicUser.jsx';
import Terms from './common/Terms.jsx';

export default function routing(store) {
  const authenticate = authenticateOnEnter.bind(this, store);

  return (
    <Route path="/" component={App}>
      <IndexRoute component={UserCheckin} onEnter={authenticate}/>
      <Route path="/login" component={Login}/>
      <Route path="/signup" component={Signup}/>
      <Route path="/forgot" component={ForgotPasswordRequest}/>
      <Route path="/forgot-password/:token" component={ForgotPasswordConsume}/>
      <Route path="/profile" component={Profile} onEnter={authenticate}>
        <IndexRoute component={ProfileInfo}/>
        <Route path="security" component={ProfileSecurity}/>
      </Route>
      <Route path="/confirm-email/:id/:token" component={ConfirmEmail}/>
      <Route path="/change-email/:id/:token" component={ChangeEmailConfirm}/>
      <Route path="/change-email-verify/:id/:token" component={ChangeEmailVerify}/>
      <Route path="/users/:id" component={PublicUser}/>
      <Route path="/terms" component={Terms}/>
      {/* should always be at the end */}
      <Route path="*" component={NotFound}/>
    </Route>
  );
}



// WEBPACK FOOTER //
// ./shared/routing.js